import React, { useEffect, useState } from "react";
import PromoIframe from "../components/PromoIframe";
import CouponData from "../couponData/CouponData";
import LiveCouponData from "../components/liveCouponData/liveCouponData";
import AdminPanelLayout from "../../../components/adminPanelLayout/AdminPanelLayout";
import { Route, Routes } from "react-router-dom";
import { isNewPromoEnabledForLob } from "../services/services";
import GenericPanel from "../../GenericPanel/GenericPanel";
import { labelMappings } from "../utils/utils";
import { Loader } from "../../../components/loader/Loader";
import { useLocation } from "react-router-dom";

const resolveIframeUrlFromEnv = (env: string): string => {
    switch (env.toLowerCase()) {
        case "uat":
            return "https://promoengineuat.salescode.ai";
        case "demo":
            return "https://promoenginedemo.salescode.ai";
        case "prod":
            return "https://promoengine.salescode.ai";
        case "prod-us-west":
            return "https://promoengine.salescode.ai";
        default:
            return "http://localhost:3000";
    }
};

// helper method to read cookie
const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

const PromoPortalWrapper = () => {
    const [isNewPromo, setIsNewPromo] = useState<boolean | null>(null);
    const [iframeUrl, setIframeUrl] = useState<string>("");
    const [tokenData, setTokenData] = useState<any>(null);
    const location = useLocation();

    const isDashboardMode = location.pathname.startsWith("/dashboard");


    useEffect(() => {
        (async () => {
            const lob = localStorage.getItem("lob") || "default";
            const env = localStorage.getItem("env") || "uat";
            const accessToken = sessionStorage.getItem("access_token") || "";
            const accessTockenExpiry = localStorage.getItem("access_token_expiry") || null;
            const loggedInUserName = JSON.parse(localStorage.getItem("authContext") || "{}")?.user?.loginId ?? "unknown";
            const lang = getCookie("i18next") || "en";



            try {
                const config = await isNewPromoEnabledForLob();


                if (config) {
                    const baseUrl = resolveIframeUrlFromEnv(env);
                    const IframeUrl = `${baseUrl}/couponDashboard`;

                    setIsNewPromo(true);
                    setIframeUrl(IframeUrl);
                    setTokenData({ accessToken, lob, env,loggedInUserName,accessTockenExpiry,lang });
                } else {
                    console.log(" Promo config returned false");

                    setIsNewPromo(false);
                }
            } catch (error) {
                setIsNewPromo(false);
            }
        })();
    }, []);

    useEffect(() => {
        const handleReloadMessage = (event: MessageEvent) => {
          if (event.data?.type === 'reload') {
            console.log('Reload message received, reloading parent');
            window.location.reload();
          }


           if (event.data?.type === "LANG_UPDATE") {
      const lang = event.data.lang || "en";
      console.log("Language update received from iframe:", lang);

      // Update parent cookie
      document.cookie = `i18next=${lang}; path=/; SameSite=None; Secure`;

      // force re-render
      setTokenData((prev: any) => ({
    ...prev,
    lang,
  }));

   // Tell i18next to actually switch language
  import("i18next").then(({ default: i18n }) => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  });
    }
        };
    
        window.addEventListener('message', handleReloadMessage);
    
        return () => {
          window.removeEventListener('message', handleReloadMessage);
        };
      }, []);
    

    const withLayout = (Component: React.ReactElement) =>
        isDashboardMode ? <AdminPanelLayout>{Component}</AdminPanelLayout> : Component;


    if (isNewPromo === null) {
        return <Loader />
    }

    if (isNewPromo) {

        return <PromoIframe iframeUrl={iframeUrl} tokenData={tokenData} />;
    }

    return (
        <Routes>
            <Route
                path=""
                element={withLayout(
                    <GenericPanel
                        configName="coupon_management_panel_options_configuration"
                        headerName={labelMappings["generic_panel_heading"] || "COUPON MANAGEMENT SYSTEM"}
                        defaultRoute="/couponDashboard"
                    />
                )}
            />
            <Route path="couponData" element={withLayout(<CouponData />)} />
            <Route path="liveCouponData" element={withLayout(<LiveCouponData />)} />
        </Routes>
    );
};

export default PromoPortalWrapper;
